import React from 'react';
import { useTranslation } from 'react-i18next';

function PriceHeaderCell() {
  const { t } = useTranslation();
  return <div className="promo-price">{t('Wholesale price')}</div>;
}

export default PriceHeaderCell;
